var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "color",
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 47",
    style: {
      enableBackground: "new 0 0 23 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9,22.7V20h4.5c0-1.1-0.9-2-2-2h-2.5h0h-0.2c0.6,0,1-0.5,0.9-1.1l-0.9-8.2c-0.2-2-1.5-3.6-3.3-4.3V1.9 c0-1.1-0.9-1.9-1.9-1.9c-1.1,0-1.9,0.9-1.9,1.9v2.5C7.8,5.1,6.5,6.7,6.3,8.7l-0.9,8.2C5.4,17.5,5.8,18,6.4,18H6.2H3.7 c-1.1,0-2,0.9-2,2h4.6v2.7h0c0,0-0.4,1.3-0.4,3.2C5.7,37.6,8.3,47,11.5,47c3.2,0,5.8-9.5,5.8-21.1C17.3,24.3,16.9,22.7,16.9,22.7 L16.9,22.7z M7.6,15.9c0,0-0.5,0.3-0.9,0c-0.7-0.5,0.9-2.8,0.9-2.8V15.9z M11.5,43.8c-1.6,0-3-4.7-3-10.4s1.3-10.4,3-10.4 c1.6,0,3,4.7,3,10.4S13.2,43.8,11.5,43.8z M14.5,11.8H8.6V8c0-1.6,1.3-3,3-3s3,1.3,3,3V11.8z M16.4,15.9c-0.4,0.3-0.9,0-0.9,0v-2.8 C15.5,13.1,17.1,15.4,16.4,15.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotoIcon);
export default __webpack_public_path__ + "static/media/moto_icon.0f8e0f03b21ef7ceba9c503725665a60.svg";
export { ForwardRef as ReactComponent };